/**
 * 班级api
 * 班级api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The MajorCreateForm model module.
   * @module basic/model/MajorCreateForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>MajorCreateForm</code>.
   * @alias module:basic/model/MajorCreateForm
   * @class
   * @param name {String} 名称
   * @param gradationId {Integer} 专业层次id
   */
  var exports = function(name, gradationId) {
    var _this = this;


    _this['name'] = name;
    _this['gradationId'] = gradationId;
  };

  /**
   * Constructs a <code>MajorCreateForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:basic/model/MajorCreateForm} obj Optional instance to populate.
   * @return {module:basic/model/MajorCreateForm} The populated <code>MajorCreateForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'code')) {
        obj['code'] = ApiClient.convertToType(data['code'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gradationId')) {
        obj['gradationId'] = ApiClient.convertToType(data['gradationId'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * 编号
   * @member {String} code
   */
  exports.prototype['code'] = undefined;
  /**
   * 名称
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 专业层次id
   * @member {Integer} gradationId
   */
  exports.prototype['gradationId'] = undefined;



  export default exports;
;


